<script>
import axios from 'axios'
import toggle from '@utils/design/toggle-info'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

import {
  infoDetailsMethods,
  actionsMethods,
  deviceActivityComputed,
  deviceEventCurrentMethods,
} from '@state/helpers'

export default {
  components: {
    VuePerfectScrollbar,
  },

  props: {
    deviceEventCurrent: {
      type: Object,
      default: () => {},
    },
  },

  data: function() {
    return {
      search: '',
      settings: {
        maxScrollbarLength: 60,
      },
    }
  },

  computed: {
    ...deviceActivityComputed,

    filteredActivities: function() {
      return this.cachedActivities.filter((activity) => {
        if (this.search.length > 0) {
          return activity.name.toLowerCase().includes(this.search.toLowerCase())
        } else {
          return this.cachedActivities
        }
      })
    },
  },

  methods: {
    ...infoDetailsMethods,
    ...actionsMethods,
    ...deviceEventCurrentMethods,

    updateActivity(activityName) {
      axios
        .post('/api/services/app/DeviceEvent/Create', {
          deviceId: this.deviceEventCurrent.deviceId,
          activityName: activityName,
        })
        .then((response) => {
          this.fetchEventCurrents({ clearCache: true }).then(() => {
            toggle()
          })
        })
        .catch((error) => {
          if (error.response && error.response.status === 401) {
            this.$router.push({
              name: 'Login',
              params: { resource: 'Interact Activity' },
            })
          }
          return null
        })
    },
  },
}
</script>

<template>
  <div>
    <b-card-body
      v-if="deviceEventCurrent"
      class="animated fadeIn card info-card pt-2 mb-0 p-0 pb-3 clearfix"
    >
      <b-row class="ml-0 mr-0 device-info-row">
        <b-col class="h5 pl-3 mb-0 text-uppercase pt-1">
          {{ deviceEventCurrent.device.name }}
          <h5 class="font-weight-bold text-uppercase mb-0">
            {{ deviceEventCurrent.activity.name }}
          </h5>
          <b-badge
            class="mr-2 text-black"
            :variant="deviceEventCurrent.activity.planned == true ? 'success' : 'danger'"
          >
            Planned
          </b-badge>
          <b-badge
            class="mr-2  text-black"
            :variant="
              deviceEventCurrent.activity.available == true ? 'success' : 'danger'
            "
            >Available
          </b-badge>
        </b-col>
      </b-row>
    </b-card-body>

    <b-card-body
      class="card list-group card-body info-card  mb-0 pl-0 pr-0 pt-2 pb-2 clearfix"
    >
      <b-form-group class="filter">
        <label for="name" class="w-100 font-weight-bold text-uppercase text-muted"
          >Search by Activity Name</label
        >
        <b-form-input
          v-model="search"
          class=" mb-2"
          placeholder="Activity Name..."
          type="text"
        ></b-form-input>
      </b-form-group>

      <VuePerfectScrollbar
        class="scroll-area "
        style="min-height: 68vh;"
        :settings="settings"
      >
        <button
          v-for="activity in filteredActivities"
          :key="activity.id"
          type="button"
          class="list-group-item list-group-item-action text-uppercase"
          @click="updateActivity(activity.name)"
        >
          {{ activity.name }}
          <br />
          <span>
            <b-badge
              class="mr-2 text-black"
              :variant="activity.planned == true ? 'success' : 'danger'"
            >
              Planned
            </b-badge>
            <b-badge
              class="mr-2  text-black"
              :variant="activity.available == true ? 'success' : 'danger'"
              >Available
            </b-badge>
          </span>
        </button>
      </VuePerfectScrollbar>
    </b-card-body>
  </div>
</template>

<style>
.scroll-area {
  position: relative;
  margin: auto;
  height: 300px;
  width: 100%;
}
.card-body-side {
  border-radius: 0px !important;
}
.tab-content {
  border-radius: 0px !important;
}
</style>
